import * as LabelPrimitive from '@radix-ui/react-label';

import { styled, theme } from '../stitches.config';
import { rem } from '../util';

export const InputLabel = styled(LabelPrimitive.Root, {
  display: 'flex',
  gap: rem(8),
  justifyContent: 'space-between',

  variants: {
    disabled: {
      true: {
        color: theme.colors.gray8,
      },
    },
  },
  color: theme.colors.blue12,
  lineHeight: 1.6,
  fontSize: theme.fontSizes.xs,
  fontWeight: theme.fontWeights.semiBold,
});
